import { render, staticRenderFns } from "./NewAMForgotPwdComponent.vue?vue&type=template&id=2f11e146&scoped=true"
import script from "./NewAMForgotPwdComponent.vue?vue&type=script&lang=js"
export * from "./NewAMForgotPwdComponent.vue?vue&type=script&lang=js"
import style0 from "./NewAMForgotPwdComponent.vue?vue&type=style&index=0&id=2f11e146&prod&lang=css"
import style1 from "./NewAMForgotPwdComponent.vue?vue&type=style&index=1&id=2f11e146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f11e146",
  null
  
)

export default component.exports